/**
 * Demo 功能权限矩阵叶子码（与 demo-function-permission-catalog.json 1:1，共 125 项）。
 * 用法：v-matrix="MatrixLeaves.BOM_1_9" 或 checkMatrixPermission(MatrixLeaves.BOM_1_9)
 */

export const MatrixLeaves = {
  // --- 项目管理 (project-management) ---
  /** 项目查看 */
  PROJECT_MANAGEMENT_1_1: 'project-management-matrix-1-1',
  /** 视图切换 */
  PROJECT_MANAGEMENT_1_2: 'project-management-matrix-1-2',
  /** 项目详情 */
  PROJECT_MANAGEMENT_1_3: 'project-management-matrix-1-3',
  // --- 项目流程 (project-flow) ---
  /** 流程查看 */
  PROJECT_FLOW_1_1: 'project-flow-matrix-1-1',
  // --- 基本信息 (basic-info) ---
  /** 查看权限 */
  BASIC_INFO_1_1: 'basic-info-matrix-1-1',
  /** 编辑权限 */
  BASIC_INFO_1_2: 'basic-info-matrix-1-2',
  // --- 需求清单 (requirements) ---
  /** 新增行 */
  REQUIREMENTS_1_1: 'requirements-matrix-1-1',
  /** 编辑行 */
  REQUIREMENTS_1_2: 'requirements-matrix-1-2',
  /** 删除行 */
  REQUIREMENTS_1_3: 'requirements-matrix-1-3',
  /** 新增列 */
  REQUIREMENTS_1_4: 'requirements-matrix-1-4',
  /** 编辑列 */
  REQUIREMENTS_1_5: 'requirements-matrix-1-5',
  /** 删除列 */
  REQUIREMENTS_1_6: 'requirements-matrix-1-6',
  /** 表单查看 */
  REQUIREMENTS_1_7: 'requirements-matrix-1-7',
  /** 生成需求 */
  REQUIREMENTS_1_8: 'requirements-matrix-1-8',
  /** 表单编辑 */
  REQUIREMENTS_1_9: 'requirements-matrix-1-9',
  /** 表单保存 */
  REQUIREMENTS_1_10: 'requirements-matrix-1-10',
  /** 导出报告 */
  REQUIREMENTS_1_11: 'requirements-matrix-1-11',
  /** 文档预览 */
  REQUIREMENTS_1_12: 'requirements-matrix-1-12',
  /** 附件上传 */
  REQUIREMENTS_1_13: 'requirements-matrix-1-13',
  /** 附件删除 */
  REQUIREMENTS_1_14: 'requirements-matrix-1-14',
  /** 字段显隐设置 */
  REQUIREMENTS_1_15: 'requirements-matrix-1-15',
  // --- BOM单 (bom) ---
  /** 新增行 */
  BOM_1_1: 'bom-matrix-1-1',
  /** 编辑行 */
  BOM_1_2: 'bom-matrix-1-2',
  /** 删除行 */
  BOM_1_3: 'bom-matrix-1-3',
  /** 新增列 */
  BOM_1_4: 'bom-matrix-1-4',
  /** 编辑列 */
  BOM_1_5: 'bom-matrix-1-5',
  /** 删除列 */
  BOM_1_6: 'bom-matrix-1-6',
  /** 生成BOM */
  BOM_1_7: 'bom-matrix-1-7',
  /** 表单查看 */
  BOM_1_8: 'bom-matrix-1-8',
  /** 成本核算 */
  BOM_1_9: 'bom-matrix-1-9',
  /** 导出报告 */
  BOM_1_10: 'bom-matrix-1-10',
  /** 表单保存 */
  BOM_1_11: 'bom-matrix-1-11',
  /** 文档预览 */
  BOM_1_12: 'bom-matrix-1-12',
  /** 附件上传 */
  BOM_1_13: 'bom-matrix-1-13',
  /** 附件删除 */
  BOM_1_14: 'bom-matrix-1-14',
  /** 字段显隐设置 */
  BOM_1_15: 'bom-matrix-1-15',
  /** 不可查看 > 成本信息字段 */
  BOM_1_16: 'bom-matrix-1-16',
  /** 不可查看 > 材料单价 */
  BOM_1_17: 'bom-matrix-1-17',
  /** 不可查看 > 含税价格 */
  BOM_1_18: 'bom-matrix-1-18',
  /** 不可查看 > 未含税价格 */
  BOM_1_19: 'bom-matrix-1-19',
  /** 可查看（除开不可查看字段以外的其余字段都可查看） */
  BOM_1_20: 'bom-matrix-1-20',
  // --- 通用部件推荐 (component-recommendation) ---
  /** 查看 */
  COMPONENT_RECOMMENDATION_1_1: 'component-recommendation-matrix-1-1',
  /** 新增 */
  COMPONENT_RECOMMENDATION_1_2: 'component-recommendation-matrix-1-2',
  /** 编辑 */
  COMPONENT_RECOMMENDATION_1_3: 'component-recommendation-matrix-1-3',
  /** 生成 */
  COMPONENT_RECOMMENDATION_1_4: 'component-recommendation-matrix-1-4',
  /** 导出 */
  COMPONENT_RECOMMENDATION_1_5: 'component-recommendation-matrix-1-5',
  /** 删除 */
  COMPONENT_RECOMMENDATION_1_6: 'component-recommendation-matrix-1-6',
  /** 字段显隐设置 */
  COMPONENT_RECOMMENDATION_1_7: 'component-recommendation-matrix-1-7',
  // --- 文档空间 (document-space) ---
  /** 文档查看 */
  DOCUMENT_SPACE_1_1: 'document-space-matrix-1-1',
  /** 文档评论 */
  DOCUMENT_SPACE_1_2: 'document-space-matrix-1-2',
  /** 文档解锁 */
  DOCUMENT_SPACE_1_3: 'document-space-matrix-1-3',
  /** 文档上传 */
  DOCUMENT_SPACE_1_4: 'document-space-matrix-1-4',
  // --- WBS任务 (wbs) ---
  /** 任务查看 */
  WBS_1_1: 'wbs-matrix-1-1',
  /** 创建任务 */
  WBS_1_2: 'wbs-matrix-1-2',
  /** 任务编辑 */
  WBS_1_3: 'wbs-matrix-1-3',
  /** 任务删除 */
  WBS_1_4: 'wbs-matrix-1-4',
  /** 任务附件上传 */
  WBS_1_5: 'wbs-matrix-1-5',
  /** 任务评论 */
  WBS_1_6: 'wbs-matrix-1-6',
  // --- 问题清单 (issues) ---
  /** 问题查看 */
  ISSUES_1_1: 'issues-matrix-1-1',
  /** 创建问题 */
  ISSUES_1_2: 'issues-matrix-1-2',
  /** 问题编辑 */
  ISSUES_1_3: 'issues-matrix-1-3',
  /** 问题评论 */
  ISSUES_1_4: 'issues-matrix-1-4',
  // --- 问题统计 (issue-statistics) ---
  /** 访问模块 */
  ISSUE_STATISTICS_1_1: 'issue-statistics-matrix-1-1',
  // --- TR评审 (tr-review) ---
  /** 发起TR评审 */
  TR_REVIEW_1_1: 'tr-review-matrix-1-1',
  /** 查看TR报告 */
  TR_REVIEW_1_2: 'tr-review-matrix-1-2',
  // --- 图纸评审（同行评审） (drawing-review) ---
  /** 查看 */
  DRAWING_REVIEW_1_1: 'drawing-review-matrix-1-1',
  /** 发起审核 */
  DRAWING_REVIEW_1_2: 'drawing-review-matrix-1-2',
  // --- 通用部件库 (component-library) ---
  /** 查看 */
  COMPONENT_LIBRARY_1_1: 'component-library-matrix-1-1',
  /** 编辑 */
  COMPONENT_LIBRARY_1_2: 'component-library-matrix-1-2',
  /** 新增 */
  COMPONENT_LIBRARY_1_3: 'component-library-matrix-1-3',
  /** 批量导入 */
  COMPONENT_LIBRARY_1_4: 'component-library-matrix-1-4',
  /** 批量删除 */
  COMPONENT_LIBRARY_1_5: 'component-library-matrix-1-5',
  // --- 智能文档 (smart-docs) ---
  /** 文档查看 */
  SMART_DOCS_1_1: 'smart-docs-matrix-1-1',
  /** 文档上传 */
  SMART_DOCS_1_2: 'smart-docs-matrix-1-2',
  /** 文档删除 */
  SMART_DOCS_1_3: 'smart-docs-matrix-1-3',
  /** 模版引用 */
  SMART_DOCS_1_4: 'smart-docs-matrix-1-4',
  /** 模版上传 */
  SMART_DOCS_2_1: 'smart-docs-matrix-2-1',
  /** 模版删除 */
  SMART_DOCS_2_2: 'smart-docs-matrix-2-2',
  /** 文档查看 */
  SMART_DOCS_2_3: 'smart-docs-matrix-2-3',
  // --- 知识空间 (knowledge) ---
  /** 上传 */
  KNOWLEDGE_1_1: 'knowledge-matrix-1-1',
  /** 标签管理 */
  KNOWLEDGE_1_2: 'knowledge-matrix-1-2',
  /** 文档属性 */
  KNOWLEDGE_1_3: 'knowledge-matrix-1-3',
  /** 重新学习 */
  KNOWLEDGE_1_4: 'knowledge-matrix-1-4',
  /** 删除 */
  KNOWLEDGE_1_5: 'knowledge-matrix-1-5',
  /** 上传 */
  KNOWLEDGE_2_1: 'knowledge-matrix-2-1',
  /** 标签管理 */
  KNOWLEDGE_2_2: 'knowledge-matrix-2-2',
  /** 文档属性 */
  KNOWLEDGE_2_3: 'knowledge-matrix-2-3',
  /** 重新学习 */
  KNOWLEDGE_2_4: 'knowledge-matrix-2-4',
  /** 删除 */
  KNOWLEDGE_2_5: 'knowledge-matrix-2-5',
  /** 上传 */
  KNOWLEDGE_3_1: 'knowledge-matrix-3-1',
  /** 标签管理 */
  KNOWLEDGE_3_2: 'knowledge-matrix-3-2',
  /** 文档属性 */
  KNOWLEDGE_3_3: 'knowledge-matrix-3-3',
  /** 重新学习 */
  KNOWLEDGE_3_4: 'knowledge-matrix-3-4',
  /** 删除 */
  KNOWLEDGE_3_5: 'knowledge-matrix-3-5',
  // --- 部门配置 (department-settings) ---
  /** 查看 */
  DEPARTMENT_SETTINGS_1_1: 'department-settings-matrix-1-1',
  /** 编辑 */
  DEPARTMENT_SETTINGS_1_2: 'department-settings-matrix-1-2',
  // --- 个人信息 (profile) ---
  /** 查看 */
  PROFILE_1_1: 'profile-matrix-1-1',
  /** 编辑 */
  PROFILE_1_2: 'profile-matrix-1-2',
  // --- 操作记录 (operation-logs) ---
  /** 访问模块 */
  OPERATION_LOGS_1_1: 'operation-logs-matrix-1-1',
  // --- 变更申请 (change-request) ---
  /** 发起审核 */
  CHANGE_REQUEST_1_1: 'change-request-matrix-1-1',
  /** 审核 */
  CHANGE_REQUEST_1_2: 'change-request-matrix-1-2',
  // --- 历史版本 (history) ---
  /** 访问模块 */
  HISTORY_1_1: 'history-matrix-1-1',
  // --- 组织架构 (organization) ---
  /** 查看 */
  ORGANIZATION_1_1: 'organization-matrix-1-1',
  /** 添加成员 */
  ORGANIZATION_1_2: 'organization-matrix-1-2',
  /** 编辑 */
  ORGANIZATION_1_3: 'organization-matrix-1-3',
  /** 移除 */
  ORGANIZATION_1_4: 'organization-matrix-1-4',
  /** 启用/停用 */
  ORGANIZATION_1_5: 'organization-matrix-1-5',
  /** 解锁/加密 */
  ORGANIZATION_1_6: 'organization-matrix-1-6',
  /** 导入 */
  ORGANIZATION_1_7: 'organization-matrix-1-7',
  /** 导出 */
  ORGANIZATION_1_8: 'organization-matrix-1-8',
  /** 新增角色 */
  ORGANIZATION_2_1: 'organization-matrix-2-1',
  /** 查看 */
  ORGANIZATION_3_1: 'organization-matrix-3-1',
  /** 添加用户 */
  ORGANIZATION_3_2: 'organization-matrix-3-2',
  /** 移除 */
  ORGANIZATION_3_3: 'organization-matrix-3-3',
  /** 查看 */
  ORGANIZATION_4_1: 'organization-matrix-4-1',
  /** 编辑 */
  ORGANIZATION_4_2: 'organization-matrix-4-2',
  /** 查看 */
  ORGANIZATION_5_1: 'organization-matrix-5-1',
  /** 编辑 */
  ORGANIZATION_5_2: 'organization-matrix-5-2',
  /** 查看 */
  ORGANIZATION_6_1: 'organization-matrix-6-1',
  /** 编辑 */
  ORGANIZATION_6_2: 'organization-matrix-6-2',
  /** 查看 */
  ORGANIZATION_7_1: 'organization-matrix-7-1',
  /** 移交所有权 */
  ORGANIZATION_7_2: 'organization-matrix-7-2',
  /** 添加管理员 */
  ORGANIZATION_8_1: 'organization-matrix-8-1',
  /** 查看 */
  ORGANIZATION_8_2: 'organization-matrix-8-2',
  /** 移除 */
  ORGANIZATION_8_3: 'organization-matrix-8-3',
} as const;

export type MatrixLeafCode = (typeof MatrixLeaves)[keyof typeof MatrixLeaves];

export const ALL_MATRIX_LEAF_CODES: MatrixLeafCode[] = Object.values(MatrixLeaves);

/** 项目详情页 UI 区域 → 叶子（便于集中引用） */
export const ProjectDetailMatrix = {
  tabRequirements: MatrixLeaves.REQUIREMENTS_1_7,
  tabBom: MatrixLeaves.BOM_1_8,
  tabComponents: MatrixLeaves.COMPONENT_RECOMMENDATION_1_1,
  tabDocuments: MatrixLeaves.DOCUMENT_SPACE_1_1,
  tabIssues: MatrixLeaves.ISSUES_1_1,
  tabWbs: MatrixLeaves.WBS_1_1,
  tabBasicInfo: MatrixLeaves.BASIC_INFO_1_1,
  navTrReview: MatrixLeaves.TR_REVIEW_1_1,
  navTrReport: MatrixLeaves.TR_REVIEW_1_2,
  navIssueStats: MatrixLeaves.ISSUE_STATISTICS_1_1,
  navOpLogs: MatrixLeaves.OPERATION_LOGS_1_1,
  navChangeRequest: MatrixLeaves.CHANGE_REQUEST_1_1,
  navChangeApprove: MatrixLeaves.CHANGE_REQUEST_1_2,
  navHistory: MatrixLeaves.HISTORY_1_1,
  navProjectFlow: MatrixLeaves.PROJECT_FLOW_1_1,
  basicInfoEdit: MatrixLeaves.BASIC_INFO_1_2,
  reqAddRow: MatrixLeaves.REQUIREMENTS_1_1,
  reqEditRow: MatrixLeaves.REQUIREMENTS_1_2,
  reqDeleteRow: MatrixLeaves.REQUIREMENTS_1_3,
  reqAddCol: MatrixLeaves.REQUIREMENTS_1_4,
  reqEditCol: MatrixLeaves.REQUIREMENTS_1_5,
  reqDeleteCol: MatrixLeaves.REQUIREMENTS_1_6,
  reqGenerate: MatrixLeaves.REQUIREMENTS_1_8,
  reqFormEdit: MatrixLeaves.REQUIREMENTS_1_9,
  reqSave: MatrixLeaves.REQUIREMENTS_1_10,
  reqExport: MatrixLeaves.REQUIREMENTS_1_11,
  reqPreview: MatrixLeaves.REQUIREMENTS_1_12,
  reqAttachUpload: MatrixLeaves.REQUIREMENTS_1_13,
  reqAttachDelete: MatrixLeaves.REQUIREMENTS_1_14,
  reqFieldVisibility: MatrixLeaves.REQUIREMENTS_1_15,
  bomAddRow: MatrixLeaves.BOM_1_1,
  bomEditRow: MatrixLeaves.BOM_1_2,
  bomDeleteRow: MatrixLeaves.BOM_1_3,
  bomAddCol: MatrixLeaves.BOM_1_4,
  bomEditCol: MatrixLeaves.BOM_1_5,
  bomDeleteCol: MatrixLeaves.BOM_1_6,
  bomGenerate: MatrixLeaves.BOM_1_7,
  bomCost: MatrixLeaves.BOM_1_9,
  bomExport: MatrixLeaves.BOM_1_10,
  bomSave: MatrixLeaves.BOM_1_11,
  bomPreview: MatrixLeaves.BOM_1_12,
  bomAttachUpload: MatrixLeaves.BOM_1_13,
  bomAttachDelete: MatrixLeaves.BOM_1_14,
  bomFieldVisibility: MatrixLeaves.BOM_1_15,
  drawingReviewView: MatrixLeaves.DRAWING_REVIEW_1_1,
  drawingReviewStart: MatrixLeaves.DRAWING_REVIEW_1_2,
  compView: MatrixLeaves.COMPONENT_RECOMMENDATION_1_1,
  compAdd: MatrixLeaves.COMPONENT_RECOMMENDATION_1_2,
  compEdit: MatrixLeaves.COMPONENT_RECOMMENDATION_1_3,
  compGenerate: MatrixLeaves.COMPONENT_RECOMMENDATION_1_4,
  compExport: MatrixLeaves.COMPONENT_RECOMMENDATION_1_5,
  compDelete: MatrixLeaves.COMPONENT_RECOMMENDATION_1_6,
  compFieldVisibility: MatrixLeaves.COMPONENT_RECOMMENDATION_1_7,
  docView: MatrixLeaves.DOCUMENT_SPACE_1_1,
  docComment: MatrixLeaves.DOCUMENT_SPACE_1_2,
  docUnlock: MatrixLeaves.DOCUMENT_SPACE_1_3,
  docUpload: MatrixLeaves.DOCUMENT_SPACE_1_4,
  issueView: MatrixLeaves.ISSUES_1_1,
  issueCreate: MatrixLeaves.ISSUES_1_2,
  issueEdit: MatrixLeaves.ISSUES_1_3,
  issueComment: MatrixLeaves.ISSUES_1_4,
  wbsView: MatrixLeaves.WBS_1_1,
  wbsCreate: MatrixLeaves.WBS_1_2,
  wbsEdit: MatrixLeaves.WBS_1_3,
  wbsDelete: MatrixLeaves.WBS_1_4,
  wbsAttach: MatrixLeaves.WBS_1_5,
  wbsComment: MatrixLeaves.WBS_1_6,
} as const;

/** 组织管理台 UI → 叶子 */
export const OrgAdminMatrix = {
  orgTreeView: MatrixLeaves.ORGANIZATION_1_1,
  orgAddMember: MatrixLeaves.ORGANIZATION_1_2,
  orgEdit: MatrixLeaves.ORGANIZATION_1_3,
  orgRemove: MatrixLeaves.ORGANIZATION_1_4,
  orgEnableDisable: MatrixLeaves.ORGANIZATION_1_5,
  orgLock: MatrixLeaves.ORGANIZATION_1_6,
  orgImport: MatrixLeaves.ORGANIZATION_1_7,
  orgExport: MatrixLeaves.ORGANIZATION_1_8,
  roleCreate: MatrixLeaves.ORGANIZATION_2_1,
  roleUsersView: MatrixLeaves.ORGANIZATION_3_1,
  roleUsersAdd: MatrixLeaves.ORGANIZATION_3_2,
  roleUsersRemove: MatrixLeaves.ORGANIZATION_3_3,
  roleFunctionView: MatrixLeaves.ORGANIZATION_4_1,
  roleFunctionEdit: MatrixLeaves.ORGANIZATION_4_2,
  roleFieldView: MatrixLeaves.ORGANIZATION_5_1,
  roleFieldEdit: MatrixLeaves.ORGANIZATION_5_2,
  roleDataView: MatrixLeaves.ORGANIZATION_6_1,
  roleDataEdit: MatrixLeaves.ORGANIZATION_6_2,
  roleOwnerView: MatrixLeaves.ORGANIZATION_7_1,
  roleTransferOwner: MatrixLeaves.ORGANIZATION_7_2,
  adminAdd: MatrixLeaves.ORGANIZATION_8_1,
  adminView: MatrixLeaves.ORGANIZATION_8_2,
  adminRemove: MatrixLeaves.ORGANIZATION_8_3,
} as const;

